module.exports = __webpack_public_path__ + "static/img_13-e3cb7ff03bc74358adfaa8d56eb94739.png";